<template>
  <div>
    <nav-header ref="navHeader"
                v-bind:showSearch="p_showSearch"
                v-bind:loginModalFlag="p_loginModalFlag"
                v-on:showLoginModal="p_showLoginModal"
                v-on:closeLoginModal="p_closeLoginModal"
    ></nav-header>
    <nav-bread>
      <span style="margin-right:10px;" slot="mine">个人中心</span>
    </nav-bread>
    <div class="container">
      <!--pc端-->
      <el-container>
        <div class="biaot"><p class="mshow">个人中心&nbsp;&nbsp;>&nbsp;&nbsp; 客户订单列表</p>
          <nav-left v-bind:activeIndex="p_activeIndex"></nav-left>
        </div>

        <el-container style="margin:10px 0 0 20px;">
          <el-header class="order mhide">订单列表</el-header>
          <el-main v-loading="loading">
            <el-row>
              <el-col :span="12" style="padding-top: 5px;">
                <el-dropdown trigger="click" @command="handleCommand">
                  <span class="el-dropdown-link">
                    {{dateRange}}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item,index) in dateRangeList" :key="index" :command="item.key">
                      {{item.value}}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-col>
              <div class="fr"><el-input
                v-model="keyword"
                placeholder="请输入商品名称或订单号开始搜索"
                style="width: 260px;vertical-align: middle;"
                @clear="search"
                @keyup.enter.native="search"
                clearable>
              </el-input><el-button type="primary" @click="search">搜索</el-button></div>
            </el-row>

            <div class="order-item" v-for="(item,index) in orderList">
              <div class="order-item-title">
                <span class="order_num">订单号：{{item.orderNum}}</span>
                <span class="ft_r">{{statusTag(item.orderStatus)}}</span>
              </div>
              <el-table
                :data="item.orderDetailList"
                :span-method="objectSpanMethod"
                border
                style="width: 100%">
                <el-table-column
                  prop="itemName"
                  label="商品名称">
                </el-table-column>
                <el-table-column
                  prop="specPrice"
                  label="单价" min-width="30">
                </el-table-column>
                <el-table-column
                  prop="spec"
                  label="规格" min-width="30">
                </el-table-column>
                <el-table-column
                  prop="itemNum"
                  label="数量" min-width="30">
                </el-table-column>
              </el-table>

              <div class="order-item-footer">
                <div class="foots">
                    <div class="footz">
                      <img src="../../assets/shop.png">
                      <span>{{item.providerName}}</span>
                    </div>
                    <div class="footy"> 共计{{item.itemNumTotal}}件商品 &nbsp; 合计：<span>￥{{item.payPrice | FormatCurrency(item.payPrice)}}</span></div>
                </div>
                <div class="footx">
                  <div class="footx_left">
                    {{item.addTime}}
                  </div>
                  <div class="footx_right">
                    <el-button type="text" v-if="item.orderStatus === 0" @click="doConfirm(item.id)">确认</el-button>
                    <el-button type="text" v-if="item.orderStatus === 0" @click="doRefuse(item.id)">拒绝</el-button>
                    <el-button type="text" @click="detailRow(item.id,item.itemNumTotal)">查看详情</el-button>
                    <el-button type="text" v-if="item.invoiceFlag === 1" @click="detailInvoice(item.orderNum)">开票信息</el-button>
                  </div>
                </div>
              </div>
            </div>

            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="limit"
              layout="prev, pager, next, jumper"
              :total="totalCount"
              v-if="orderList.length"
              style="text-align:center">
            </el-pagination>
            <div class="empty" v-if="orderList.length===0 && !loading">
              当前没有订单信息哦
            </div>
          </el-main>

        </el-container>
      </el-container>
    </div>

    <!--发票信息弹框-->
    <invoice-add-or-update v-if="invoiceVisible" ref="invoice"></invoice-add-or-update>

    <!--移动端-->
    <div class="mshow">
      <!--底部导航-->
      <tabbar :selected="selected" :tabs='tabs'></tabbar>
    </div>
  </div>

</template>

<script>
  import axios from 'axios'
  import Tabbar from '@/components/Tabbar.vue'
  import NavHeader from '@/components/Header.vue'
  import NavFooter from '@/components/Footer.vue'
  import NavBread from '@/components/Bread.vue'
  import NavLeft from '@/components/NavLeft.vue'
  import '@/assets/css/index.css'
  import {getCookie, removeHTMLTag, delCookie} from "../../util/util"
  import InvoiceAddOrUpdate from '../../components/invoice-add-or-update'

  export default {
    name: "mine",
    data() {
      return {
        selected: "Mine",
        tabs: [
          require("@/assets/hose_grey.png"),
          require("@/assets/shopping_grey.png"),
          require("@/assets/me_Filled.png")
        ],
        limit: 5,
        page: 1,
        orderList: [],
        p_activeIndex: "8",
        loading: true,
        totalPage: 0,
        totalCount: 0,
        currentPage: 1,
        maxDetailLength: 1,
        p_showSearch:true,
        p_loginModalFlag:false,
        isChannel:true,
        keyword:"",
        interval:{},
        p_mdshow:false,
        //查询时间段
        beginTime: '',
        dateRangeList: [
          {
            key: '',
            value: '不限时间'
          },
          {
            key: '1week',
            value: '近一周'
          },
          {
            key: '1month',
            value: '近一个月'
          },
          {
            key: '3month',
            value: '近三个月'
          },
          {
            key: '6month',
            value: '近半年'
          },
          {
            key: '1year',
            value: '近一年'
          }
        ],
        dateRange: '不限时间',
        // 订单状态
        orderStatusList: [
          {
            status: 0,
            label: '待确认'
          },
          {
            status: 1,
            label: '已确认'
          },
          {
            status: 2,
            label: '部分发货'
          },
          {
            status: 3,
            label: '全部发货'
          },
          {
            status: 4,
            label: '订单完成'
          },
          {
            status: 5,
            label: '客户取消'
          },
          {
            status: 6,
            label: '厂家取消'
          }
        ],
        // 发票
        invoiceVisible: false
      }
    },
    components: {
      Tabbar,
      NavHeader,
      NavFooter,
      NavBread,
      NavLeft,
      InvoiceAddOrUpdate
    },
    computed: {
      user() {
        return this.$store.state.user;
      },
      statusTag () {
        return function (code) {
          return (this.orderStatusList.find(e => e.status === code) || { label: '暂无' }).label
        }
      }
    },
    mounted() {
      if (getCookie("_token")) {
        this.getOrderList()
      } else {
        this.$message({
          showClose: true,
          message: '登录信息失效,请重新登录',
          type: 'error'
        });
        this.p_showLoginModal()
      }
    },
    methods: {
      p_showLoginModal(){
        this.p_loginModalFlag = true
      },

      p_closeLoginModal(){
        this.p_loginModalFlag = false
      },

      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },

      handleCurrentChange(val) {
        this.page = val
        this.getOrderList()
      },

      getOrderList() {
        axios.get('/jys/channelorder/list', {
          params: {
            limit: this.limit,
            page: this.page,
            itemName: this.keyword,
            beginTime:this.beginTime
          },
          headers: {
            "Content-Type": "application/json",
            'token': getCookie("_token")
          }
        }).then((response) => {
          let res = response.data
          if(res.code === 0){
            this.loading = false
            this.orderList = res.page.list
            let detailLengthList = []
            for (let i = 0; i <  this.orderList.length; i++) {
              let orderDetailArr = this.orderList[i].orderDetailList
              let len = this.orderList[i].orderDetailList.length
              detailLengthList.push(len)

              this.orderList[i].itemNumTotal = 0
              for (let j = 0; j < orderDetailArr.length; j++) {
                this.orderList[i].itemNumTotal += orderDetailArr[j].itemNum
              }
            }

            //获取最大行数,合并单元格
            this.maxDetailLength = Math.max.apply(null,detailLengthList)
            this.totalPage = res.page.totalPage
            this.totalCount = res.page.totalCount
            // this.currentPage = res.page.currPage
          }else if(res.code == 401){
            this.loading = false
            this.$message({
              showClose: true,
              message: '登录信息失效,请重新登录',
              type: 'error'
            });
            this.$refs.navHeader.logout()
          }
        })
      },

      //查看详情
      detailRow(id, itemNumTotal) {
        this.$router.push({
          path: '/mine/orderDesc',
          query: {
            id: id,
            orderType : 1,
            p_activeIndex: '8',
            itemNumTotal: itemNumTotal
          }
        })
      },

      //查看发票
      detailInvoice(orderNum) {
        this.invoiceVisible = true
        this.$nextTick(() => {
          this.$refs.invoice.init(orderNum)
        })
      },

      //确认
      doConfirm(id) {
        this.$confirm('确定进行[确认]订单操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios.put('/jys/channelorder/confirm/' + id, {
          }).then((response) => {
            if (response.data.code === 0) {
              this.$message({
                message: '确认成功',
                type: 'success'
              });
              this.getOrderList()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消确认'
          });
        });
      },

      //拒绝
      doRefuse(id) {
        this.$confirm('确定进行[拒绝]订单操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios.put('/jys/channelorder/cancel/' + id, {
          }).then((response) => {
            if (response.data.code === 0) {
              this.$message({
                message: '拒绝成功',
                type: 'success'
              });
              this.getOrderList()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消拒绝'
          });
        });
      },

      //搜索
      inputKey(){
        this.getOrderList()
      },

      search(){
        this.page = 1
        this.currentPage = 1
        this.getOrderList()
      },

      objectSpanMethod({row, column, rowIndex, columnIndex}) {
        if (columnIndex === 4) {
          if (rowIndex % this.maxDetailLength === 0) {
            return {
              rowspan: this.maxDetailLength,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      },

      //根据时间段搜索
      handleCommand(command) {
        // 先获取当前时间
        let curDate = (new Date()).getTime();
        let pastResult = '';

        if(command){
          if(command == '1week'){
            //近一周
            this.dateRange = '近一周'
            let dateTemp = 7 * 24 * 3600 * 1000;
            pastResult = curDate - dateTemp;  // 毫秒单位

          }else if(command == '1month'){
            //近一个月
            this.dateRange = '近一个月'
            let dateTemp = 365 / 12 * 24 * 3600 * 1000;
            pastResult = curDate - dateTemp;

          }else if(command == '3month'){
            //近三个月
            this.dateRange = '近三个月'
            let dateTemp = 365 / 4 * 24 * 3600 * 1000;
            pastResult = curDate - dateTemp;

          }else if(command == '6month'){
            //近半年
            this.dateRange = '近半年'
            let dateTemp = 365 / 2 * 24 * 3600 * 1000;
            pastResult = curDate - dateTemp;

          }else if(command == '1year'){
            //近一年
            this.dateRange = '近一年'
            let dateTemp = 365 * 24 * 3600 * 1000;
            pastResult = curDate - dateTemp;

          }

          // 日期函数，定义起点为半年前
          let pastDate = new Date(pastResult);
          let pastYear = pastDate.getFullYear();
          let pastMonth = pastDate.getMonth() + 1;
          let pastDay = pastDate.getDate();

          if (pastMonth >= 1 && pastMonth <= 9) {
            pastMonth = "0" + pastMonth;
          }
          if (pastDay >= 0 && pastDay <= 9) {
            pastDay = "0" + pastDay;
          }

          this.beginTime = pastYear + '-' + pastMonth + '-' + pastDay;
        }else{

          this.dateRange = '不限时间'
          this.beginTime = ''
        }

        this.keyword = ''
        this.search()

      },

      // 跳转到店铺
      toCompany(id) {
        this.$router.push({path: "/company/index", query: {id: id}})
      }
    }
  }
</script>

<style scoped>
  .el-dropdown{
    cursor: pointer;
  }

  .order-item {
    margin-bottom: 20px;
  }

  .order-item-title {
    /*width:100%;*/
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    background-color: #F5F5F5;
    text-align: left;
  }

  .total-price {
    display: block;
    color: #FE2042;
    font-size: 16px;
  }

  .empty {
    width: 100%;
    height: 200px;
    line-height: 200px;
    text-align: center;
    background-color: #fff;
  }

  .el-button--text{

  }
 .fr{
   float: right;
 }

  .order .el-input__inner {
    padding-left: 30px;
    text-align: center;
  }

  .order-item-footer{
       border: 1px solid #ebeef5;
    border-top: none;
    padding: 10px;
  }
  .foots{
    display: flex;font-size: 11px;
    margin-bottom: 10px;
    justify-content: space-between;
  }
  .footz{
    color: #999;
  }
  .footz img{
    width: 14px;
    height: 14px;
  }
  .footy span{
    color: red;
  }
  .footx{
    display: flex;
    justify-content: space-between;
  }
  .footx_left{
    font-size: 12px;
    color: #999;
  }
  .footx_right{
    margin-top: 15px;
  }

  .chaka,.pay {
    width: 70px;
    height: 26px;
    line-height: 26px;
    border-radius: 12px;
    margin-left: 10px;
    vertical-align: middle;
    font-size: 11px;
    cursor: pointer;
    text-align: center;
    color: #03DAC4;
    border: 0.5px solid rgba(0, 197, 177, 1);
  }
  .pay{
    color:#FE2042;
    border: 0.5px solid #FE2042;
    line-height: 8px;
  }
  .mshow{
    display: none;}


  .ft_r{
    float: right;
    font-weight: bolder;
    color: #4A4A4A;
  }

  .order_time{
    font-weight: bolder;
    color: #4A4A4A;
  }

  .order_num{
    padding-left: 10px;
    color: #4A4A4A;
  }
  .el-button--primary {
      vertical-align: middle;box-sizing: content-box;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .container{
      width: 95%;
      margin: 0 auto 70px;
    }
    .el-col-12 {
     width: initial;
}

    .biaot {
      background-color: #F0F0F0;
      color: #333;
      font-size: 11px;
      text-align: left;
      position: relative;
      line-height: 32px;
      margin: 0 -10px 0;
      padding: 0 10px;
      border-left: 5px solid #00C5B0;
    }
    .mshow{
    display: inline-block;}
    .biaot div {
      position: absolute;
      right: 0;
      height: 32px;
      top: 0;
    }


    .mhide{
        display: none;}
    /deep/ .el-container{
      margin-left: 0!important;
    }
    /deep/ .el-pagination button {
      min-width: initial;
    }
    /deep/ .el-pagination .btn-prev {
      padding-right: 0;
    }
    /deep/ .el-pagination{
      margin-left: 0px;
    }

    /deep/ .el-pagination .btn-next {
      padding-left: 0;
    }
    /deep/ .el-pagination__jump {
      margin-left: 0;
      display: none!important;
    }
    .order-item-title {
      padding: 0 6px;
      font-size: 12px;
    }
    .el-main{
      padding: 10px;
    }
    .total-price {
      white-space: nowrap;
      font-size: 12px;
    }
    .order-item-title span{
      width: 70px;
      overflow: hidden;
      white-space: nowrap;
    }
    /deep/ .el-dialog {
      width: 98%!important;
    }
    /deep/ .el-pager li {
      min-width: 32px;
    }
    .el-input{

      width: 190px!important;
    }
    /deep/ .header a{

      overflow: hidden;
      white-space: nowrap;
    }
    /deep/ .navbar-right-container,/deep/ .navbar-left-container img,/deep/ .hideel{
      display: none!important;
    }
    /deep/ .out{
      color: rgba(0, 196, 170, 1);
      padding-left: 0;
      margin-right: 20px;
    }
    /deep/ .el-button--text {
      line-height: 11px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/user/CustomerList.vue